// export const serverUrl = {
//     baseURL: 'http://localhost:8443/adminApi/',//测试环境
//     baseURLFinal: 'http://localhost:8443/',//测试环境
//     //baseURL: 'https://api.yiliit.com/adminApi/',//正式环境
//     // baseURL: 'https://api.1j1kj.cn/adminApi',
//     uploadUrl: 'https://api.yiliit.com/file/uploadObjectOSS',
//     imgUrl: 'https://one-stand-new.oss-cn-shanghai.aliyuncs.com/'
// }

export const serverUrl = {
    // baseURL: '/adminApi/',//测试环境
    baseURL: 'https://api.1j1kj.cn/adminApi/',//正式环境
    uploadUrl: 'https://api.1j1kj.cn/file/uploadObjectOSS',
    imgUrl: 'https://yjy-one-stand.oss-cn-heyuan.aliyuncs.com/',
}


// WEBPACK FOOTER //
// ./src/utils/server.js